import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import ticker from "../../assets/images/tick.svg";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../context/NotificationProvider";

const Finish = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const { showMessage } = useNotification();

  const confirm = async () => {
    setIsLoading(true);

    try {
      await refreshUser();

      navigate("/");
    } catch (error) {
      showMessage(
        "error",
        "There was an issue confirming your email as verified."
      );
    }
  };

  return (
    <>
      {/* <OnboardingHeader title={'Verify ID'} /> */}
      {/* <Header
                className="shadow-md border-b border-gray-300 flex items-center text-center w-full"
                //style={{ height: "70px" }}
            >
                <img src={logo} alt="Logo" width="50" />
            </Header> */}
      <div className="relative min-h-screen flex flex-col items-center justify-center bg-white text-">
        {/* Main Content */}
        <div className="z-10 mt-1 flex flex-col items-center space-y-6">
          <img
            //src="/assets/icons/tick.svg"
            src={ticker}
            alt="finish"
            width={100}
            height={100}
            className="mx-auto"
          />
          <h2 className="mt-6 text-2xl font-bold text-brand-primary">
            You're all set!
          </h2>
          <p className="text-sm text-center text-gray-600 max-w-md">
            Your account is ready to go. Let’s make some investment magic.
          </p>
          <button
            onClick={confirm}
            disabled={isLoading}
            className={`mt-6 h-14 w-96 rounded-full font-semibold text-white transition-transform duration-200 shadow-lg ${
              isLoading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 transform hover:scale-105"
            }`}
          >
            {isLoading ? "Preparing dashboard..." : "View Dashboard"}
          </button>
        </div>

        {/* Bottom Gradient Overlay */}
        <div className="absolute bottom-0 left-0 w-full h-64 bg-gradient-to-t from-bg-light-gray-2 to-transparent pointer-events-none" />
      </div>
    </>
  );
};

export default Finish;
